export default __webpack_public_path__ + "static/media/Two Buttons.68722785.svg";